<template>
	<layout activeLabel="留言列表">
		<div class="card">
			<div class="message flex-row" v-for="item in list" :key="item.id">
				<el-image class="logo" :src="$imgUrl + item.photo"
					fit="cover"></el-image>
				<div class="info">
					<div class="name">{{item.name}}</div>
					<div class="desc">
						{{item.content}}<span class="status">【未读{{item.weidu}}条】</span>
					</div>
<!--					<div class="desc">-->
<!--						{{item.content}}-->
<!--					</div>-->
				</div>
				<div class="button" @click="openCustomerServer(item)">留言</div>
			</div>
		</div>
	</layout>
</template>

<script>
	import layout from "./index.vue";
	import {
		contactIndexListApi, readtypechange2
	} from '../../http/api/user.js'
	export default {
		name: "leaveMessage",
		components: {
			layout
		},
		data() {
			return {
				list: []
			}
		},
		created() {
			this.getList()
		},
		methods: {
			getList(){
				contactIndexListApi({
					type: 1
				}).then(res => {
					this.list = res
				})
			},
			openCustomerServer(item){
				if(item.weidu>0){
					readtypechange2({id:item.id}).then(res=>{
						// console.log(res)

					})
				}
				this.$router.push({
					path: '/service',
					query: {
						contactType: item.contactType,
						contactId: item.contactId
					}
				})
			}
		}
	};
</script>
<style lang="less" scoped>
	.card {
		min-height: 7rem;
	}

	.message {
		padding: 0.3rem 0.24rem 0.3rem 0.38rem;
		box-sizing: border-box;
		border-bottom: 1px solid #e8e8e8;
		justify-content: space-between;
		align-items: center;

		.logo {
			width: 0.58rem;
			height: 0.58rem;
			margin-right: 0.16rem;
			border-radius: 0.06rem;
		}

		.info {
			flex: 1;
			margin-right: 20px;

			.name {
				line-height: 0.22rem;
				font-size: 0.14rem;
				font-weight: 500;
				color: #000000;
				padding-bottom: 0.22rem;
			}

			.desc {
				line-height: 0.18rem;
				font-size: 0.13rem;
				font-weight: 400;
				color: #979797;

				.status {
					color: #ff4141;
				}
			}
		}

		.button {
			width: 0.94rem;
			height: 0.34rem;
			background: #ffffff;
			border-radius: 0.06rem;
			opacity: 1;
			border: 1px solid #ff8f27;
			font-size: 0.14rem;
			line-height: 0.34rem;
			color: #ff8f27;
			text-align: center;
			cursor: pointer;
		}
	}
</style>
